export default __webpack_public_path__ + "static/media/RookiePool.4e1232b5.png";